// import 'pdfjs-dist/web/pdf_viewer.css'
import tool from "@/template/js/v32/tool";
import load from "@/conf/js/load";

/** The PDF */


class PDFManager {

    static defaultScale = 1.2;
    static boxWidth = 650;

    /**
     * Show the PDF document in HTML
     * @param {PDFDocumentProxy} doc
     * @param successFun
     * @return PDFDocumentProxy
     */
    static async #loadDocument(doc, successFun) {
        const container = document.getElementById("pageContainer");
        const eventBus = new pdfjsViewer.EventBus();
        //
        for (let i = 1; i <= doc.numPages; i++) {
            await doc.getPage(i).then((pdfPage) => {
                let maxScale = this.boxWidth / pdfPage.getViewport({scale: 1}).width
                let viewport = pdfPage.getViewport({scale: maxScale});
                // Create the page view.
                const pdfPageView = new pdfjsViewer.PDFPageView({
                    container: container,
                    id: i,
                    scale: maxScale,
                    defaultViewport: viewport,
                    eventBus: eventBus,
                    annotationLayerFactory: new pdfjsViewer.DefaultAnnotationLayerFactory(),
                    textLayerFactory: new pdfjsViewer.DefaultTextLayerFactory(),
                    renderInteractiveForms: true,
                });
                pdfPageView.setPdfPage(pdfPage);
                return pdfPageView.draw();
            });
        }
        //加载成功
        successFun && successFun()
        return doc;
    }


    /**
     * 更新filed
     * @param field
     */

    static updateField(field) {
        if (field) {
            let ele = null
            for(let i in field) {
                ele = document.getElementsByName(i)[0];
                if (ele)
                    ele.value = field[i];
            }

        }
    }


    /**
     * 重新计算尺寸
     */
    static   computerBoxSize() {
        let container = document.getElementsByClassName("page");
        let width = 0, height = 0, style = null;
        for (let element of container) {
            style = window.getComputedStyle(element);
            height += parseInt(style.height.replace("px", ""));
            width = parseInt(style.width);
        }
        let clientWidth = document.body.clientWidth;
        let scale = clientWidth / width;
        if (scale < 1) {
            document.getElementById("pageContainer").style.width = width - 10 + 'px';
            document.getElementById("pageContainer").style.height = (height  ) + 'px';
            document.getElementById("pageContainer").style.transform = "scale(" + scale + ")"
            document.getElementById("pageContainer").style.transformOrigin = "0 0"
            document.getElementById("pageContainer").style.overflow = "hidden"
            document.getElementById("pageContainer").parentElement.style.height = (height  * scale + 70) + 'px';
            document.getElementById("pageContainer").parentElement.parentElement.style.minHeight = (height * scale + 70 ) + 'px';
        }
    }

    /**
     * Load the PDF in the viewer
     * @return PDFDocumentProxy
     */
    static async loadPDF(file_url , fill_field , field, loadSuccessFun) {

        pdfjsLib.GlobalWorkerOptions.workerSrc = "/js/"+pVersion+"/pw.min.js";

        load.css("js/viewer.css")

        const doc = await pdfjsLib.getDocument({
            url : file_url,
            cMapUrl: "https://oss2.1dq.com/pdf/js/cmaps/",
            cMapPacked: true
        }).promise;


        return  this.#loadDocument(doc, ()=>{
            //计算尺寸
            this.computerBoxSize()
            //更新field
            setTimeout(()=>{
                //初始化输入框
                field &&  tool.init(field).handle()
                //更新内容
                fill_field &&  tool.updateFillField(fill_field)
                //输出内容
                document.getElementById("pageContainer").setAttribute("class", "showCanvas")
                //加载成功
                loadSuccessFun && loadSuccessFun()
            }, 1000)
        })

    }


}

export {PDFManager};
